import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import { getStoreBadgeSrc, type StoreBadge } from './getStoreBadgeSrc'

interface Props {
  store: StoreBadge
  alt: string
  className?: string
}

const Badge = styled(Image)`
  max-width: 100%;
`

function StoreDownloadBadge({ store, alt, className }: Props) {
  const intl = useIntl()

  return (
    <Badge
      className={className}
      image={{ url: getStoreBadgeSrc(store, intl.locale) }}
      alt={alt}
      height={40}
    />
  )
}

export default StoreDownloadBadge
